import { filterVAByNotifications } from './filterVAByNotifications';

export function enrichDataWithUIRecipients(events = [], notifications = []) {
  if (!events.length || !notifications.length) return events;

  const notificationsVAArr = notifications.filter((n) => n.filters?.type) || [];

  if (!notificationsVAArr.length) return events;

  return events.map((event) => {
    if (!event.event_type) return event;

    const matchedNotification = notificationsVAArr.find((n) =>
      filterVAByNotifications(event, n)
    );

    if (!matchedNotification) return event;

    return {
      ...event,
      uiRecipients: {
        sound: matchedNotification.ui?.recipients?.sound ?? false,
        popup: matchedNotification.ui?.recipients?.popup ?? false,
      },
    };
  });
}
